import { call, put, takeEvery } from 'redux-saga/effects';
import {
  createBookmarkRequest,
  createBookmarkSuccess,
  createBookmarkFailure,
} from '../slice/createBookmarkSlice';
import { createBookmarkApi } from '@src/api/apiService';
import { getApiError } from "@src/utils/apiError";


interface BookmarkErrorResponse { error?: string; session_id?: string[]; }
interface ApiError { response?: { data?: BookmarkErrorResponse; }; message?: string; }
// Worker saga
export function* handleCreateBookmark(action: ReturnType<typeof createBookmarkRequest>): Generator<any, void, any> {
  try {
    const response = yield call(createBookmarkApi as any, action.payload);
    yield put(createBookmarkSuccess(response.data));
  } catch (error: unknown) {
    const apiError = getApiError(error);
    yield put(
        createBookmarkFailure(
            apiError.message
        )
    );
  }
}

// Watcher saga
export function* createBookmarkSaga() {
  yield takeEvery(createBookmarkRequest.type, handleCreateBookmark);
}
